import React, { ReactElement } from "react";

import { CardWrapper, ContentWrapper } from "./styles";

interface Props {
  children: Array<ReactElement> | ReactElement;
  isSmall?: boolean;
  contentTestId?: string;
  disableBorder?: boolean;
}
const OutlinedCardItem = ({
  children,
  isSmall = false,
  contentTestId,
  disableBorder = false,
}: Props) => (
  <CardWrapper $disableBorder={disableBorder}>
    <ContentWrapper
      $isSmall={isSmall}
      data-testid={contentTestId}
    >
      {children}
    </ContentWrapper>
  </CardWrapper>
);

export default OutlinedCardItem;
